module.exports = __webpack_public_path__ + "static/img/pf.b51ab54c.svg";